export const SetCurrentPageTopic = (topic) => {
    return {
        type:"GET_TOPIC",
        topic : topic
    };
};